import React from "react";
import Chips from "../../Chips";
import Tooltip from "../../Tooltip";

import { IGameTableType } from "@/types/GlobalTypes";

import "./index.scss";
import { betGroupProp } from "@/modules/commonMobile";

export default class M24 extends React.PureComponent<IGameTableType> {
	render() {
		const { langdata } = this.props;

		const commonChipProps = {
			mobile: this.props.mobile,
			chipBase: this.props.chipBase,
			bets: this.props.bets,
			betOutOfBounds: this.props.betOutOfBounds
		}

		const commonTooltipProps = {
			langStr: langdata.language_code
		};

		return this.props.portrait ? (
			<div className="sl-table m24 full_v3">
				<div className="row">
					{
						[3, 2, 1].map((item, idx) =>
							<div className={"sl-bet col-xs-4 taller sl-baccarat-bet-blue"}
								key={`dP1${idx}`}
								{...betGroupProp(this, `doublePlayer${item}`, "double")}
								// bet={`doublePlayer${item}`} group="double" pcode={this.props.pcode}
								onClick={this.props.insertBet}>
								<div>Double</div>
								<div className="bet-type">1:0.95</div>
								<Chips betKey={`doublePlayer${item}+double`} {...commonChipProps} />
							</div>
						)
					}
				</div>

				<div className="row">
					{
						[3, 2, 1].map((item, idx) =>
							<div className={"sl-bet col-xs-4 taller sl-baccarat-bet-blue"}
								key={`eP2${idx}`}
								{...betGroupProp(this, `equalPlayer${item}`, "equal")}
								// bet={`equalPlayer${item}`} group="equal" pcode={this.props.pcode}
								onClick={this.props.insertBet}>
								<div>Equal</div>
								<div className="bet-type">1:0.95</div>
								<Chips betKey={`equalPlayer${item}+equal`} {...commonChipProps} />
							</div>
						)
					}
				</div>

				<div className="row">
					{
						[3, 2, 1].map((item, idx) =>
							<div className={"sl-bet col-xs-4 sl-baccarat-bet-dark-blue"}
								key={`p3${idx}`}>
								<div>Player {item}</div>
							</div>
						)
					}
				</div>
			</div>
		) : this.props.maximised ? (
			<div className="sl-table table-m24">
				{
					[3, 2, 1].map((item, idx) => [
						<div key={"max_m24_g_1_" + idx}
							className="sl-bet"
							{...betGroupProp(this, `doublePlayer${item}`, "double")}
							// bet={`doublePlayer${item}`} group="double" pcode={this.props.pcode}
							onClick={this.props.insertBet}>
							<div>Double</div>
							<div className="bet-type">1:0.95</div>
							<Chips betKey={`doublePlayer${item}+double`} {...commonChipProps} />
							<Tooltip {...commonTooltipProps} bet={this.props.bets[`doublePlayer${item}+double`]} />
						</div>
						,
						<div key={"max_m24_g_2_" + idx}
							className="sl-bet"
							{...betGroupProp(this, `equalPlayer${item}`, "equal")}
							// bet={`equalPlayer${item}`} group="equal" pcode={this.props.pcode}
							onClick={this.props.insertBet}>
							<div>Equal</div>
							<div className="bet-type">1:0.95</div>
							<Chips betKey={`equalPlayer${item}+equal`} {...commonChipProps} />
							<Tooltip {...commonTooltipProps} bet={this.props.bets[`equalPlayer${item}+equal`]} />
						</div>
					]
					)
				}

				<br />

				<div>Player 3</div>
				<div>Player 2</div>
				<div>Player 1</div>
			</div>
		) : (
					<div className="sl-table m24">
						{
							[3, 2, 1].map((item, idx) => (
								<div key={"m24_g_" + idx} className="group">
									<div className="top">
										<div className="sl-bet sl-green-old"
											key={`dP5${idx}`}
											{...betGroupProp(this, `doublePlayer${item}`, "double")}
											// bet={`doublePlayer${item}`} group="double" pcode={this.props.pcode}
											onClick={this.props.insertBet}>
											<div>Double</div>
											{/* <div className="bet-type">1:1</div> */}
											<Chips betKey={`doublePlayer${item}+double`} {...commonChipProps} />
											<Tooltip {...commonTooltipProps} bet={this.props.bets[`doublePlayer${item}+double`]} />
										</div>
										<div className="sl-bet sl-green-old"
											key={`eP6${idx}`}
											{...betGroupProp(this, `equalPlayer${item}`, "equal")}
											// bet={`equalPlayer${item}`} group="equal" pcode={this.props.pcode}
											onClick={this.props.insertBet}>
											<div>Equal</div>
											{/* <div className="bet-type">1:1</div> */}
											<Chips betKey={`equalPlayer${item}+equal`} {...commonChipProps} />
											<Tooltip {...commonTooltipProps} bet={this.props.bets[`equalPlayer${item}+equal`]} />
										</div>
									</div>
									<div className="bottom">
										Player {item}
									</div>
								</div>
							))
						}
					</div>
				);
	}
}